import { render, staticRenderFns } from "./SafesReport.vue?vue&type=template&id=22891c51&"
import script from "./SafesReport.vue?vue&type=script&lang=js&"
export * from "./SafesReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports